import { Box, Popover, Popper } from '@mui/material';
import SearchContact from 'components/add-contact-modal/components/simple-search-contact';
import ContactCreation from 'components/users/form-contact-creation/contact-creation';
import React, { useRef, useState } from 'react';

type Props = {
  disabled?: boolean;
  onSelectParty: (contact: { _id: string; name: string } | null) => void;
  className?: string;
  clearTextOnSelect?: boolean
};

export const SearchPartyInput: React.FC<Props> = ({
  disabled,
  onSelectParty,
  className,
  clearTextOnSelect
}) => {
  const searchContainerRef = useRef<HTMLDivElement>(null);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [showForm, setShowForm] = useState(false);
  const id = showForm ? 'simple-popover' : undefined;
  const [newContactKind, setNewContactKind] = useState<string>('Person');
  const [searchContactText, setSearchContactText] = useState<string | undefined>();

  return (
    <Box>
      <div ref={searchContainerRef}>
        <SearchContact
          className={className}
          disabled={disabled}
          aria-describedby={id}
          getValue={(user) => {
            onSelectParty(user);
          }}
          handleContactCreation={(kind, searchText) => {
            setNewContactKind(kind);
            setSearchContactText(searchText);
            setShowForm(true);
            setAnchorEl(searchContainerRef.current);
          }}
          initialValue={undefined}
          clearTextOnSelect={clearTextOnSelect}
          popperComponent={(props) => (
            <Popper {...props} placement="bottom-start" />
          )}
        />
      </div>
      <Popover
        id={id}
        open={showForm}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setShowForm(false);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box
          display="flex"
          flex="1"
          flexDirection="column"
          style={{ padding: 8, width: "500px" }}
        >
          <ContactCreation
            searchText={searchContactText}
            selectedKind={newContactKind}
            kindList={['Person', 'Organization']}
            onSuccess={({ _id, name }) => {
              setShowForm(false);
              onSelectParty({ _id, name });
            }}
            handleCancel={() => {
              setShowForm(false);
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
};
